<template>
  <div>
    <checkbox-component
        :id="name"
        @checkbox:change="onChange"
        :error="error"
        class="align-items-start term-checkbox"
    >
      <terms-policy class="cw-terms">
        <template v-slot:prev>I Accept the</template>
        <template v-slot:middle>and</template>
      </terms-policy>
    </checkbox-component>
  </div>
</template>

<script>
import CheckboxComponent from './CheckboxComponent';
import termsPolicy from '@/components/base-components/termsPolicy.vue';

export default {
  name: 'TermsCheckbox',
  components: {
    termsPolicy,
    CheckboxComponent,
  },
  props: {
    name: {
      type: String,
      default: 'terms',
    },
    error: {
      type: String,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('checkbox:change', {
        name: this.name,
        value: e.target.checked,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.term-checkbox {
  --checkbox-top-offset: .3rem;
}
</style>

<style lang="scss">
.cw-terms {
  background: transparent;
  a {
    color: var(--theme-link-accent);
    text-transform: uppercase;
    &:hover {
      color: var(--theme-link-accent);
    }
  }
}
</style>
